module.exports = __webpack_public_path__ + "static/media/popin-bck.2f515dac.png";